import { render, staticRenderFns } from "./Rechazo.vue?vue&type=template&id=1b4ebdef"
import script from "./Rechazo.vue?vue&type=script&lang=js"
export * from "./Rechazo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b4ebdef')) {
      api.createRecord('1b4ebdef', component.options)
    } else {
      api.reload('1b4ebdef', component.options)
    }
    module.hot.accept("./Rechazo.vue?vue&type=template&id=1b4ebdef", function () {
      api.rerender('1b4ebdef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/certificados/oficial-registro/Rechazo.vue"
export default component.exports